import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { APIgetDuplicates } from '../../api/Files';
import { formatBytes } from '../../helpers/Files';

const EmptyDuplicates = () => {
  const intl = useIntl();

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [duplicatesTotals, setDuplicatesTotals] = useState(null);

  const showCountInfo = () => {
    if (!duplicatesTotals) return false;

    if (
      duplicatesTotals.images === 0 &&
      duplicatesTotals.similar_images === 0 &&
      duplicatesTotals.files === 0
    ) return false;

    return true;
  };

  const getDuplicateSummary = () => {
    const parts = [];

    if (duplicatesTotals.images > 0) {
      parts.push(
        <FormattedMessage
          defaultMessage="<strong>{count}</strong> duplicate images"
          values={{
            count: duplicatesTotals.images,
            strong: (msg) => <strong>{msg}</strong>,
          }}
        />,
      );
    }

    if (duplicatesTotals.similar_images > 0) {
      parts.push(
        <FormattedMessage
          defaultMessage="<strong>{count}</strong> similar images"
          values={{
            count: duplicatesTotals.similar_images,
            strong: (msg) => <strong>{msg}</strong>,
          }}
        />,
      );
    }

    if (duplicatesTotals.files > 0) {
      parts.push(
        <FormattedMessage
          defaultMessage="<strong>{count}</strong> duplicate files"
          values={{
            count: duplicatesTotals.files,
            strong: (msg) => <strong>{msg}</strong>,
          }}
        />,
      );
    }

    if (parts.length === 0) return null;

    let formattedMessage;
    if (parts.length === 1) {
      formattedMessage = parts[0];
    } else if (parts.length === 2) {
      formattedMessage = (
        <FormattedMessage
          defaultMessage="{first} and {second}"
          values={{
            first: parts[0],
            second: parts[1],
          }}
        />
      );
    } else {
      formattedMessage = (
        <>
          {parts.slice(0, -1).map((part, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={index}>{part}{index < parts.length - 2 ? ', ' : ' '}</span>
          ))}
          <FormattedMessage
            defaultMessage="and {last}"
            values={{ last: parts[parts.length - 1] }}
          />
        </>
      );
    }

    return (
      <FormattedMessage
        defaultMessage="You have {items}."
        values={{
          items: formattedMessage,
          strong: (msg) => <strong>{msg}</strong>,
          size: formatBytes(duplicatesTotals.size),
        }}
      />
    );
  };

  useEffect(() => {
    if (loading) {
      return;
    }

    if (!page) {
      setPage(1);
      return;
    }

    setLoading(true);
    APIgetDuplicates({ page }).then((response) => {
      const {
        totals,
      } = response.data;

      setDuplicatesTotals(totals);
      setLoading(false);
    });
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!showCountInfo()) return null;

  return (
    <>
      <div className="mt-2 violet">
        {getDuplicateSummary()}
      </div>
      <div className="mb-3 violet">
        {intl.formatMessage(
          {
            defaultMessage: 'You can save up to <strong>{size}</strong>.',
          },
          {
            strong: (msg) => <strong>{msg}</strong>,
            size: formatBytes(duplicatesTotals.size),
          },
        )}
      </div>
    </>
  );
};

export default EmptyDuplicates;
